import React, { useEffect, useMemo, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import fetchProfile from "../../../api/userProfile";
import SidebarItem from "./SidebarItem";
import "./css/Sidebar.scss";

interface Menu {
  name: string;
  path: string;
  submenu?: Menu[];
  auth?: string[];
}

const LEGACY_MENU_KEY = "__legacy__";

const primaryMenus: Menu[] = [
  { name: "dalgoT 운영 콘솔", path: "/dalgoT/operations-console" },
  { name: "스냅샷 확인", path: "/adddiLight/imageList" },
  { name: "서울버스로그", path: "/statusLog" },
  { name: "업데이트 파일 관리", path: "/versionManager/update", auth: ["admin", "ai"] },
  { name: "API 명세", path: "/developer/api", auth: ["admin", "ai"] },
];

const legacyMenus: Menu[] = [
  {
    name: "버전관리",
    path: "/versionManager/folder",
    submenu: [
      { name: "폴더 불러오기", path: "/versionManager/folder" },
      { name: "매체별 히스토리", path: "/versionManager/history" },
    ],
  },
  {
    name: "파일 조회",
    path: "/inquiry",
    submenu: [
      { name: "LOG 조회", path: "/inquiry/logInquiryList" },
      { name: "CSV 조회", path: "/inquiry/csvInquiryList" },
    ],
  },
  {
    name: "광고",
    path: "/adComponent/ad/adList",
    submenu: [
      { name: "광고", path: "/adComponent/ad/adList" },
      { name: "광고 사업 분류", path: "/adComponent/adCorpField/adCorpFieldList" },
      { name: "광고 분류", path: "/adComponent/adField/adFieldList" },
      { name: "광고 정보", path: "/adComponent/adVideoInfo/adVideoInfoList" },
      { name: "광고주", path: "/adComponent/advertiser/advertiserList" },
    ],
  },
  {
    name: "매체",
    path: "/mediaComponent/media/list",
    submenu: [
      { name: "매체", path: "/mediaComponent/media/list" },
      { name: "매체 기기", path: "/mediaComponent/mediaDevice/mediaDeviceList" },
      { name: "매체 네트워크", path: "/mediaComponent/mediaNetwork/mediaNetworkList" },
      { name: "매체 좌표", path: "/mediaComponent/mediaPoint/list" },
    ],
  },
  { name: "비즈니스", path: "/businessType/businessTypeList" },
  { name: "CPV", path: "/cpv/cpvList" },
  {
    name: "장소",
    path: "/siteComponent/site/list",
    submenu: [
      { name: "장소", path: "/siteComponent/site/list" },
      { name: "장소 분류", path: "/siteComponent/siteField/siteFieldList" },
    ],
  },
  {
    name: "AI 기기",
    path: "/aiComponent/aiDevice/aiDeviceList",
    submenu: [
      { name: "AI 기기", path: "/aiComponent/aiDevice/aiDeviceList" },
      { name: "AI 기기 종류", path: "/aiComponent/aiDeviceType/aiDeviceTypeList" },
      { name: "AI 기기 이슈", path: "/aiComponent/aiDeviceIssue/aiDeviceIssueList" },
      { name: "AI 기기 업체", path: "/aiComponent/aiDeviceCompany/aiDeviceCompanyList" },
      { name: "AI 모듈", path: "/aiComponent/aiModule/aiModuleList" },
    ],
  },
  {
    name: "카메라",
    path: "/cameraComponent/camera/cameraList",
    submenu: [
      { name: "카메라", path: "/cameraComponent/camera/cameraList" },
      { name: "카메라 종류", path: "/cameraComponent/cameraType/cameraTypeList" },
    ],
  },
  {
    name: "데이터",
    path: "/effectComponent/dailyEffect/dailyEffectList",
    submenu: [
      { name: "일간 데이터", path: "/effectComponent/dailyEffect/dailyEffectList" },
      { name: "일간 Real 데이터", path: "/effectComponent/dailyRealEffect/dailyRealEffectList" },
      { name: "시간 데이터", path: "/effectComponent/hourlyEffect/hourlyEffectList" },
      { name: "시간 Real 데이터", path: "/effectComponent/hourlyRealEffect/hourlyRealEffectList" },
      { name: "매체 데이터", path: "/effectComponent/mediaEffect/mediaEffectList" },
      { name: "광고 데이터", path: "/effectComponent/adlyEffect/adlyEffectList" },
    ],
  },
  {
    name: "그래프",
    path: "/graphComponent/dailyRealEffectGraphs/dailyRealEffectGraphsList",
    submenu: [
      { name: "일간 Real 데이터 그래프", path: "/graphComponent/dailyRealEffectGraphs/dailyRealEffectGraphsList" },
    ],
  },
  {
    name: "네트워크",
    path: "/networkComponent/networkDevice/networkDeviceList",
    submenu: [
      { name: "네트워크 기기", path: "/networkComponent/networkDevice/networkDeviceList" },
      { name: "네트워크 기기 종류", path: "/networkComponent/networkDeviceType/networkDeviceTypeList" },
    ],
  },
  {
    name: "관제",
    path: "/dashboard",
    submenu: [
      { name: "일간 데이터 관제", path: "/dashboard/daily" },
      { name: "주간 데이터 관제", path: "/dashboard/weekly" },
      { name: "광고 다운로드 관제", path: "/dashboard/ad" },
      { name: "스케줄러 관제", path: "/dashboard/schedule" },
    ],
  },
  {
    name: "달고T 관제",
    path: "/dalgoT",
    submenu: [
      { name: "월간 데이터 관제", path: "/dalgoT/monthly" },
      { name: "일간 데이터 관제", path: "/dalgoT/daily" },
      { name: "경로 관리", path: "/dalgoT/path" },
      { name: "매체 관제", path: "/dalgoT/media" },
    ],
  },
  {
    name: "AL 관제",
    path: "/adddiLight/registrationList",
    submenu: [
      { name: "실시간 기기 등록", path: "/adddiLight/registrationList" },
    ],
  },
  { name: "설치 문서", path: "/installReport/installReportList" },
];

const menuContainsPath = (menu: Menu, pathname: string): boolean =>
  pathname === menu.path ||
  pathname.startsWith(`${menu.path}/`) ||
  Boolean(menu.submenu?.some((item) => menuContainsPath(item, pathname)));

const canViewMenu = (menu: Menu, userGroup: string | null): boolean =>
  !menu.auth || Boolean(userGroup && menu.auth.includes(userGroup));

function Sidebar() {
  const location = useLocation();
  const sidebarRef = useRef<HTMLElement>(null);
  const [expandedMenu, setExpandedMenu] = useState<string | null>(null);
  const [selectedLegacyPath, setSelectedLegacyPath] = useState<string>(legacyMenus[0].path);
  const [userGroup, setUserGroup] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const profileData = await fetchProfile();
        if (profileData?.status === 200) setUserGroup(profileData.data?.userGroup || null);
      } catch {
        setUserGroup(null);
      }
    };

    fetchProfileData();
  }, []);

  useEffect(() => {
    const closeFlyout = (event: PointerEvent) => {
      if (!sidebarRef.current?.contains(event.target as Node)) setExpandedMenu(null);
    };
    const closeWithEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setExpandedMenu(null);
    };

    document.addEventListener("pointerdown", closeFlyout);
    document.addEventListener("keydown", closeWithEscape);
    return () => {
      document.removeEventListener("pointerdown", closeFlyout);
      document.removeEventListener("keydown", closeWithEscape);
    };
  }, []);

  const activePrimary = useMemo(
    () => primaryMenus.find((menu) => canViewMenu(menu, userGroup) && menuContainsPath(menu, location.pathname)),
    [location.pathname, userGroup],
  );
  const activeLegacy = useMemo(
    () =>
      activePrimary
        ? undefined
        : legacyMenus.find((menu) => menuContainsPath(menu, location.pathname)),
    [activePrimary, location.pathname],
  );
  const visiblePrimaryMenus = primaryMenus.filter((menu) => canViewMenu(menu, userGroup));
  const expandedPrimary = visiblePrimaryMenus.find((menu) => menu.path === expandedMenu);
  const visiblePrimarySubmenu = expandedPrimary?.submenu?.filter((item) => canViewMenu(item, userGroup)) || [];
  const selectedLegacy = legacyMenus.find((menu) => menu.path === selectedLegacyPath) || legacyMenus[0];
  const visibleLegacySubmenu = selectedLegacy.submenu?.filter((item) => canViewMenu(item, userGroup)) || [];
  const legacyExpanded = expandedMenu === LEGACY_MENU_KEY;

  const toggleLegacyMenu = () => {
    if (legacyExpanded) {
      setExpandedMenu(null);
      return;
    }

    setSelectedLegacyPath(activeLegacy?.submenu?.length ? activeLegacy.path : legacyMenus[0].path);
    setExpandedMenu(LEGACY_MENU_KEY);
  };

  return (
    <aside className="sidebar" ref={sidebarRef} aria-label="주요 메뉴">
      <div className="sidebar__heading">
        <span className="sidebar__eyebrow">WORKSPACE</span>
        <strong>AI Operations</strong>
      </div>

      <nav className="sidebar__nav">
        {visiblePrimaryMenus.map((menu) => {
          const hasSubmenu = Boolean(menu.submenu?.length);
          const isExpanded = expandedMenu === menu.path;
          const isActive = activePrimary?.path === menu.path;

          return hasSubmenu ? (
            <button
              type="button"
              className={`sidebar__menu-button${isActive ? " is-active" : ""}`}
              aria-expanded={isExpanded}
              aria-controls={isExpanded ? "sidebar-flyout" : undefined}
              key={menu.path}
              onClick={() => setExpandedMenu(isExpanded ? null : menu.path)}
            >
              <SidebarItem menu={menu} active={isActive} hasSubmenu expanded={isExpanded} userGroup={userGroup} />
            </button>
          ) : (
            <NavLink
              to={menu.path}
              className={`sidebar__menu-link${isActive ? " is-active" : ""}`}
              key={menu.path}
              onClick={() => setExpandedMenu(null)}
            >
              <SidebarItem menu={menu} active={isActive} userGroup={userGroup} />
            </NavLink>
          );
        })}
      </nav>

      <div className="sidebar__legacy-area">
        <span className="sidebar__legacy-label">ARCHIVE</span>
        <button
          type="button"
          className={`sidebar__menu-button sidebar__legacy-button${activeLegacy ? " is-active" : ""}`}
          aria-expanded={legacyExpanded}
          aria-controls={legacyExpanded ? "sidebar-legacy-flyout" : undefined}
          onClick={toggleLegacyMenu}
        >
          <SidebarItem
            menu={{ name: "Legacy Menu", path: LEGACY_MENU_KEY }}
            active={Boolean(activeLegacy)}
            hasSubmenu
            expanded={legacyExpanded}
            userGroup={userGroup}
          />
        </button>
      </div>

      <div className="sidebar__footer">
        <span className="sidebar__status-dot" />
        AI DATA PLATFORM
      </div>

      {expandedPrimary && (
        <section className="sidebar-flyout" id="sidebar-flyout" aria-label={`${expandedPrimary.name} 하위 메뉴`}>
          <div className="sidebar-flyout__header">
            <div>
              <span>MENU</span>
              <strong>{expandedPrimary.name}</strong>
            </div>
            <button type="button" onClick={() => setExpandedMenu(null)} aria-label="하위 메뉴 닫기">×</button>
          </div>
          <div className="sidebar-flyout__links">
            {visiblePrimarySubmenu.map((subItem, index) => (
              <NavLink
                to={subItem.path}
                key={subItem.path}
                className={({ isActive }) => (isActive ? "is-active" : "")}
                onClick={() => setExpandedMenu(null)}
              >
                <span>{String(index + 1).padStart(2, "0")}</span>
                {subItem.name}
                <i aria-hidden="true">↗</i>
              </NavLink>
            ))}
          </div>
        </section>
      )}

      {legacyExpanded && (
        <section className="sidebar-flyout sidebar-flyout--legacy" id="sidebar-legacy-flyout" aria-label="Legacy Menu">
          <div className="sidebar-flyout__header">
            <div>
              <span>ARCHIVE</span>
              <strong>Legacy Menu</strong>
            </div>
            <button type="button" onClick={() => setExpandedMenu(null)} aria-label="Legacy Menu 닫기">×</button>
          </div>

          <div className="legacy-menu">
            <div className="legacy-menu__groups" aria-label="Legacy 메뉴 그룹">
              {legacyMenus.map((menu, index) => {
                const hasSubmenu = Boolean(menu.submenu?.length);
                const isSelected = selectedLegacy.path === menu.path;
                const isActive = activeLegacy?.path === menu.path;

                return hasSubmenu ? (
                  <button
                    type="button"
                    className={`${isSelected ? "is-selected" : ""}${isActive ? " is-active" : ""}`}
                    key={menu.path}
                    onClick={() => setSelectedLegacyPath(menu.path)}
                  >
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    {menu.name}
                    <i aria-hidden="true">›</i>
                  </button>
                ) : (
                  <NavLink
                    to={menu.path}
                    className={isActive ? "is-active" : ""}
                    key={menu.path}
                    onClick={() => setExpandedMenu(null)}
                  >
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    {menu.name}
                    <i aria-hidden="true">↗</i>
                  </NavLink>
                );
              })}
            </div>

            <div className="legacy-menu__detail">
              <div className="legacy-menu__detail-heading">
                <span>LEGACY GROUP</span>
                <strong>{selectedLegacy.name}</strong>
              </div>
              <div className="legacy-menu__links">
                {visibleLegacySubmenu.map((subItem, index) => (
                  <NavLink
                    to={subItem.path}
                    key={subItem.path}
                    className={({ isActive }) => (isActive ? "is-active" : "")}
                    onClick={() => setExpandedMenu(null)}
                  >
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    {subItem.name}
                    <i aria-hidden="true">↗</i>
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}
    </aside>
  );
}

export default Sidebar;
